import { Contract } from '../../types/header/Contract';

export const useReactivateDeals = (): ReactivateDealsType => {
  const canReactivateDeal = (contract: Contract, amVehicleId: string): boolean => {
    return contract?.amVehicleStyleExists && !!amVehicleId;
  };

  const updateMake = (contract: Contract, make: string): void => {
    let brandName = make;
    if (brandName === 'Gmc' || brandName === 'Mini' || brandName === 'Infiniti') {
      brandName = brandName.toUpperCase();
    }
    const style = contract.vehicleStyle;
    const year = style.slice(0, 4);
    const trim = style.slice(4);
    contract.vehicleStyle = year + ' ' + brandName + trim;
  };

  const updateSoldBy = (contract: Contract): void => {
    const soldbyUpperCase = contract.soldBy ? contract.soldBy.toUpperCase() : '';
    // when soldBy is "serviceMastermind", set it to "Service-to-Sales"
    if (soldbyUpperCase === 'SERVICEMASTERMIND' || soldbyUpperCase === 'SERVICE MASTERMIND') {
      contract.soldBy = 'Service-to-Sales';
    }
  };

  const updateVehicleType = (contract: Contract): void => {
    const vehicleTypes = [
      { name: 'New', value: true },
      { name: 'Pre-owned', value: false },
    ];

    contract.vehicleType = (contract.isNew && vehicleTypes[0]) || vehicleTypes[1];
  };

  return { canReactivateDeal, updateMake, updateSoldBy, updateVehicleType };
};

type ReactivateDealsType = {
  canReactivateDeal: (contract: Contract, amVehicleId: string) => boolean;
  updateMake: (contract: Contract, make: string) => void;
  updateSoldBy: (contract: Contract) => void;
  updateVehicleType: (contract: Contract) => void;
};
